import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

const Page = () => <Index toolKey="tips" routeLang="es" />;

export const Route = createFileRoute("/consejos")({
  head: () => publicToolHead("tips", "es"),
  component: Page,
  errorComponent: Page,
  notFoundComponent: Page,
});
